import {
  VALID_ACTION_ON_NULL_VALUES,
  DEFAULT_ACTION_ON_NULL,
} from '../constants/eligibilityEngine';

// Normalizes any stored actionOnNull value to one of VALID_ACTION_ON_NULL_VALUES.
// Handles legacy/lowercase values ('deny', 'ignore_rule') and unsupported
// legacy values ('move_to_pending') by falling back to DEFAULT_ACTION_ON_NULL.
export const normalizeActionOnNull = value => {
  if (!value) return DEFAULT_ACTION_ON_NULL;
  const upper = String(value).toUpperCase();
  const match = VALID_ACTION_ON_NULL_VALUES.find(
    v => upper === v || upper.startsWith(`${v}_`),
  );
  return match || DEFAULT_ACTION_ON_NULL;
};
